import type { ReactNode } from 'react'
import React from 'react'

import * as S from './Info.styled'

type Props = {
  children: ReactNode
}

export const Info = ({ children }: Props) => {
  if (!children) {
    return null
  }

  return <S.Container>{children}</S.Container>
}
